import React from "react";
import Modal from "../../../components/Modal/Modal";
import gif from "../../../assets/gif/inbox.gif";

const TypeChangeWarningModal = ({ show, onConfirm, onCancel }) => {
  return (
    <Modal width="450px" show={show} onClose={onCancel}>
      <div className="py-3 text-center">
        <div className="flex justify-center mt-[-20px]">
          <img src={gif} alt="warning" height={120} width={120} />
        </div>
        <div className="flex-1 mt-4 text-center">
          <p className="head-1 dark-H font-bold">Are you sure?</p>
          <p className="py-1 dark-M body-L">Changing the type will clear the selected users. Do you want to continue?</p>
        </div>
        <div className="mt-6 flex justify-center">
          <button type="button" onClick={onConfirm} className="save-button light-L head-5 green-bg-H">
            Confirm
          </button>
          <button type="button" onClick={onCancel} className="green-H body-N ml-5">
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TypeChangeWarningModal;
